module.exports = __webpack_public_path__ + "Guarantee Icon.bc795d91.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/landing/Guarantee Icon.png
// module id = NXYH
// module chunks = 0